import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import { useDebouncedState } from '../../utils/useDebouncedState';

const SIZE_SLIDER_BG = 'assets/images/size-slider-bg.svg';
const OPACITY_SLIDER_BG = 'assets/images/opacity-slider-bg.svg';

interface Props {
  min?: number;
  max?: number;
  value?: number;
  onChange?: (value: number) => void;
  opacityColor?: string;
}

const Slider = ({ max = 100, min = 0, value, onChange, opacityColor }: Props) => {
  const backgroundImage = opacityColor ? OPACITY_SLIDER_BG : SIZE_SLIDER_BG;
  const [valueDebounced, onChangeDebounced] = useDebouncedState(value, onChange);

  const sliderStyle = {
    '--gradient-color': opacityColor ?? 'transparent',
  } as CSSProperties;

  return (
    <div
      className={classNames('slider__wrapper', {
        'slider__wrapper--opacity': opacityColor,
      })}
    >
      <div
        className="slider__background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={valueDebounced}
        className="slider"
        style={sliderStyle}
        onChange={(e) => onChangeDebounced?.(Number(e.target.value))}
      />
    </div>
  );
};

export default Slider;
